import './_lrpQuotes/styles/lrpQuotes.scss';

import { useEffect, useState } from 'react';

import { CasPage, CasDatePicker, CasTableToolbar } from 'src/compass/shared/components';
import useRetrieve from 'src/compass/shared/hooks/reactQuery/useRetrieve';
import { DateFormat, formatDate } from 'src/compass/shared/util/casMoment';
import { useExportOption } from 'src/compass/shared/util/useExportOption';
import LrpQuotesContainer from './_lrpQuotes/components/LrpQuotesContainer';

interface Filters {
  selectedQuoteDate: string | null;
}

type LrpQuotesPageProps = { isPublicPage?: boolean }

const defaultFilters = { selectedQuoteDate: null };

const getLRPQuotesTitle = (date: string | null) => {
  if (!date) return 'LRP Quotes';
  const formattedDate = formatDate(date, DateFormat.M_D_YY_ddd);
  return `LRP Quotes: ${formattedDate}`;
};

export default function LrpQuotesPage({ isPublicPage = false } : LrpQuotesPageProps) {
  const [currentFiltersValues, setCurrentFiltersValues] = useState<Filters>({ ...defaultFilters });
  const [displayFiltersValues, setDisplayFiltersValues] = useState<Filters>({ ...defaultFilters });

  const tabsInfoQueryResult = useRetrieve({ url: '/LRP/Quotes/tabs'});
  const quotesQueryResult = useRetrieve({ url: '/LRP/Quotes', params: currentFiltersValues });
  const { data, isFetching } = quotesQueryResult;
  const { latestQuoteDate } = data || {};

  useEffect(() => {
    if (displayFiltersValues.selectedQuoteDate === null && latestQuoteDate) {
      setDisplayFiltersValues({ selectedQuoteDate: latestQuoteDate });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [latestQuoteDate]);

  const { exportOption } = useExportOption({
    entity: 'LRP/Quotes',
    params: displayFiltersValues,
    includeExport: !!displayFiltersValues.selectedQuoteDate,
  });

  const handleFilters = (_: string, value: string) => {
    setCurrentFiltersValues({ selectedQuoteDate: value });
    setDisplayFiltersValues({ selectedQuoteDate: value });
  };

  return (
    <CasPage
      title={getLRPQuotesTitle(displayFiltersValues.selectedQuoteDate)}
      pageTitle="Endorsements"
      className="lrpQuotesPage"
    >
      {!(isPublicPage || isFetching) && (
        <CasTableToolbar
          buttons={[]}
          filters={[
            {
              type: 'component',
              name: 'selectedQuoteDate',
              label: 'Quote Date',
              component: CasDatePicker,
              componentProps: { canClear: false }
            },
          ]}
          currentFilterValues={displayFiltersValues}
          onFilterChange={handleFilters}
          options={exportOption}
        />
      )}

      <LrpQuotesContainer quotesQueryResult={quotesQueryResult} tabsInfoQueryResult={tabsInfoQueryResult} />
    </CasPage>
  );
}
